import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { Logo } from '@/components/Logo';

export function TermsPage() {
  const { t } = useTranslation('terms');

  return (
    <div className="min-h-dvh bg-k-canvas">
      {/* Nav */}
      <nav className="border-b-2 border-brand-indigo bg-k-canvas/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5">
            <Logo className="h-9 w-9 text-brand-indigo" />
            <span className="font-display text-lg font-bold tracking-tight text-brand-indigo">
              AgentCAD
            </span>
          </Link>
          <LanguageSwitcher />
        </div>
      </nav>

      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-1.5 text-sm font-bold text-brand-indigo transition-colors hover:underline"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('backToTop')}
        </Link>

        <div className="rounded-2xl border-2 border-brand-indigo/15 bg-k-card p-6 sm:p-10">
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-brand-indigo sm:text-4xl">
            {t('title')}
          </h1>
          <p className="mt-2 text-sm font-semibold text-brand-indigo/60">{t('lastUpdated')}</p>

          <div className="mt-10 space-y-8 text-base leading-relaxed text-k-ink/90">
            {[
              'application',
              'account',
              'serviceContent',
              'ip',
              'disclaimer',
              'changes',
              'law',
            ].map((sec) => (
              <section key={sec}>
                <h2 className="mb-3 font-display text-xl font-bold text-brand-indigo">
                  {t(`sections.${sec}.heading`)}
                </h2>
                <p>{t(`sections.${sec}.body`)}</p>
              </section>
            ))}

            <section>
              <h2 className="mb-3 font-display text-xl font-bold text-brand-indigo">
                {t('sections.prohibited.heading')}
              </h2>
              <ul className="list-inside list-disc space-y-1.5">
                {(t('sections.prohibited.items', { returnObjects: true }) as string[]).map(
                  (item, i) => (
                    <li key={i}>{item}</li>
                  ),
                )}
              </ul>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
